import { render, staticRenderFns } from "./column-mapping-component.vue?vue&type=template&id=a4e54e48&scoped=true&"
import script from "./column-mapping-component.vue?vue&type=script&lang=js&"
export * from "./column-mapping-component.vue?vue&type=script&lang=js&"
import style0 from "./column-mapping-component.vue?vue&type=style&index=0&id=a4e54e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e54e48",
  null
  
)

export default component.exports